import { useParams } from 'react-router-dom'

import {
  GetTaskDetailsDocument,
  MaterializedProcessDocument,
  TasksValueObjectsTaskIdentifierEnum,
} from 'generated/resources/graphql'

import { useBulkUpdateTasks } from 'modules/tasks/hooks/useBulkUpdateTasks'

interface IVariable {
  id: string
  done: boolean
  identifier?: TasksValueObjectsTaskIdentifierEnum
}

type ResolveTaskProps = {
  variables: IVariable
}

export const useResolveTask = () => {
  const { materializedProcessId } = useParams()
  const { bulkUpdateTasks, loading } = useBulkUpdateTasks()

  return {
    resolveTask: ({ variables }: ResolveTaskProps) => {
      return bulkUpdateTasks({
        variables: {
          tasks: [
            {
              id: variables.id,
              status: variables.done ? 'done' : 'todo',
              identifier: variables.identifier,
            },
          ],
        },
        refetchQueries: materializedProcessId
          ? [{ query: GetTaskDetailsDocument }, { query: MaterializedProcessDocument }]
          : [{ query: GetTaskDetailsDocument }],
      })
    },
    loading,
  }
}
